import React, { useContext, useEffect, useRef, useState, useMemo } from "react";
import DashboardHeader from "../dashboard/DashboardHeader/DashboardHeader";
import CollapseBlock from "../dashboard/CollapseBlockLeft/collapseblockleft";
import CollapseBlockRight from "../dashboard/collapseblockright/collapseblockright";
import CustomSvg from "../svgs/CustomSvg";
import { useNavigate } from "react-router-dom";
import { getRequest, postRequest } from "../apiRequests/requestApi";
import { Spinner } from "react-bootstrap";
import CustomErrorMsg from "../errorMsg/CustomErrorMsg";
import socket from "../../socket";
import { GamesContext } from "../../utils/contexts/GameContext";
import { UserContext } from "../../utils/contexts/UserContext";
import PropTypes from 'prop-types';

// const myLobbies = [
//   {
//     stakeValue: 5000,
//     gameId: "chess",
//     roomId: "qufh_24J__-!",
//     user_id: "1",
//   },
//   {
//     stakeValue: 5000,
//     gameId: "chess",
//     roomId: "qufh_24J__-!",
//     user_id: "1",
//   },
//   {
//     stakeValue: 5000,
//     gameId: "chess",
//     roomId: "qufh_24J__-!",
//     user_id: "1",
//   },
//   {
//     stakeValue: 5000,
//     gameId: "chess",
//     roomId: "qufh_24J__-!",
//     user_id: "1",
//   },
// ];

const NAVIGATION_TABS = [
  { id: 'myLobbies', label: 'My Lobbies' },
  { id: 'enterPin', label: 'Enter Pin' },
  { id: 'qrCode', label: 'Scan QR Code' },
];

const OTP_LENGTH = 6;
const INITIAL_API_STATE = {
  isLoading: false,
  data: null,
  errorMsg: null,
};

const NavigationTab = ({ id, label, isActive, onClick }) => (
  <div
    onClick={() => onClick(id)}
    className={`tab-item clickable col-lg-2 col-md-5 col-3 align-items-center justify-content-center p-2  p-lg-2 mb-lg-0 mb-md-0 mb-4 ${
      isActive ? 'bg-BD3193' : 'bg-transparent join-lobby-inactive-route'
    }`}
  >
    <p className="m-0 p-0 text-center txt-FFF font-weight-500 regular-txt font-family-poppins">
      {label}
    </p>
  </div>
);

NavigationTab.propTypes = {
  id: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  isActive: PropTypes.bool.isRequired,
  onClick: PropTypes.func.isRequired,
};

const EnterPinButton = ({ isLoading, disabled, onClick }) => (
  <button
    disabled={isLoading || disabled}
    style={{ opacity: isLoading || disabled ? 0.5 : 1 }}
    onClick={onClick}
    className="enter-btn w-100 bg-BD3193 d-flex align-items-center justify-content-center p-2 mb-5"
  >
    {isLoading ? (
      <div className="py-1">
        <Spinner size="sm" variant="light" />
      </div>
    ) : (
      <>
        <p className="p-0 m-0 small-txt txt-FFF font-weight-500 font-family-poppins mx-1">
          Enter
        </p>
        <div className="m-0 p-0 mx-2 d-flex align-items-center">
          <CustomSvg name="arrow-right" />
        </div>
      </>
    )}
  </button>
);

EnterPinButton.propTypes = {
  isLoading: PropTypes.bool.isRequired,
  disabled: PropTypes.bool.isRequired,
  onClick: PropTypes.func.isRequired,
};

const EnterPin = () => {
  const navigate = useNavigate();
  const { user } = useContext(UserContext);
  const inputRefs = useRef([]);

  const [apiReqs, setApiReqs] = useState(INITIAL_API_STATE);
  const [otp, setOtp] = useState(new Array(OTP_LENGTH).fill(''));

  useEffect(() => {
    if (apiReqs.data && apiReqs.isLoading) {
      submit(apiReqs.data);
    }
  }, [apiReqs]);

  const handleChange = (element, index) => {
    setOtp((prevOtp) => 
      prevOtp.map((d, idx) => (idx === index ? element.value : d))
    );
    
    if (element.nextSibling && element.value) {
      inputRefs.current[index + 1].focus();
    }
  };

  const handleKeyDown = (e, index) => {
    if (e.key === 'Backspace' && !otp[index] && inputRefs.current[index - 1]) {
      inputRefs.current[index - 1].focus();
    }
  };

  const initiateJoinLobby = () => {
    const lobbyCode = otp.join('');
    setApiReqs({
      isLoading: true,
      data: { lobbyCode },
      errorMsg: null,
    });
  };

  const submit = async (requestBody) => {
    try {
      const response = await postRequest({
        url: '/join-lobby',
        data: requestBody,
      });

      const { message, success } = response;

      if (success) {
        socket.emit(
          'lobby-joined',
          user._id,
          requestBody.lobbyCode,
          (response) => {
            const { gameName } = response;
            navigate(`/waiting-room/${gameName}/${requestBody.lobbyCode}`);
            setApiReqs(INITIAL_API_STATE);
          }
        );
        return;
      }

      setApiReqs({ ...INITIAL_API_STATE, errorMsg: message });
    } catch (error) {
      setApiReqs({
        ...INITIAL_API_STATE,
        errorMsg: error.message || 'Error joining lobby',
      });
    }
  };

  const btnDisabled = otp.join('').length !== OTP_LENGTH;

  return (
    <div className="enter-pin-container">
      {apiReqs.errorMsg && (
        <CustomErrorMsg errorMsg={apiReqs.errorMsg} verticalPadding={true} />
      )}

      <div className="otp-inputs-container d-flex align-items-center justify-content-between mb-4 gap-2 pb-3">
        {otp.map((data, index) => (
          <input
            key={index}
            type="text"
            name="otp"
            maxLength="1"
            value={data}
            onChange={(e) => handleChange(e.target, index)}
            onKeyDown={(e) => handleKeyDown(e, index)}
            ref={(el) => (inputRefs.current[index] = el)}
            className="email-verify-input p-3 col-lg-1 col-md-2 col-1 text-center font-family-source-sans txt-FFF medium-txt"
            onPaste={(e) => {
              const paste = e.clipboardData.getData('text').replace(/\D/g, '');
              if (paste.length === OTP_LENGTH) {
                setOtp(paste.split('').slice(0, OTP_LENGTH));
                setTimeout(() => {
                  inputRefs.current[OTP_LENGTH - 1]?.focus();
                }, 0);
                e.preventDefault();
              }
            }}
          />
        ))}
      </div>

      <EnterPinButton
        isLoading={apiReqs.isLoading}
        disabled={btnDisabled}
        onClick={initiateJoinLobby}
      />

      <div className="resend-code-container">
        <p className="p-0 m-0 opacity-_8 text-center letter-spacing-_22 line-height-30 font-weight-300 small-txt txt-FFF font-family-poppins">
          Didn't receive email? <br /> You can resend code in{' '}
          <span className="txt-BD3193">55s</span>
        </p>
      </div>
    </div>
  );
};

const LobbyItem = ({ lobby, onLobbyClick }) => {
  const { _id, participants, wagerAmount, gameId } = lobby;
  
  return (
    <div
      className="lobby-item bg-transparent join-lobby-inactive-route rounded-3 p-2"
      onClick={() => onLobbyClick({
        user_id: participants[0],
        stakeValue: wagerAmount,
        gameId,
        roomID: _id,
      })}
    >
      <p className="p-0 px-2 m-0 opacity-_8 text-center letter-spacing-_22 line-height-30 font-weight-300 small-txt txt-FFF font-family-poppins">
        {gameId}
      </p>
    </div>
  );
};

LobbyItem.propTypes = {
  lobby: PropTypes.shape({
    _id: PropTypes.string.isRequired,
    participants: PropTypes.arrayOf(PropTypes.string).isRequired,
    wagerAmount: PropTypes.number.isRequired,
    gameId: PropTypes.string.isRequired,
  }).isRequired,
  onLobbyClick: PropTypes.func.isRequired,
};

const MyLobbies = () => {
  const navigate = useNavigate();
  const [myLobbies, setMyLobbies] = useState([]);

  useEffect(() => {
    const fetchLobbies = async () => {
      try {
        const [gamesResponse, lobbiesResponse] = await Promise.all([
          getRequest('games'),
          getRequest('/mylobbies'),
        ]);

        const games = gamesResponse?.data;
        const gameLookup = games.reduce((lookup, game) => {
          lookup[game._id] = game.name;
          return lookup;
        }, {});

        const { data, message } = lobbiesResponse;
        const gameSessionsWithNames = data.map((session) => ({
          ...session,
          gameId: gameLookup[session.gameId],
        }));

        setMyLobbies(gameSessionsWithNames);
        alert(message);
      } catch (error) {
        // console.error('Error fetching lobbies:', error);
      }
    };

    fetchLobbies();
  }, []);

  const handleLobbyClick = ({ gameName, lobbyCode }) => {
    navigate(`/waiting-room/${gameName}/${lobbyCode}`);
  };

  return (
    <div className="my-lobbies-container">
      <div>
        {myLobbies.length > 0 ? (
          <>
            <div className="lobbies-grid d-flex align-items-center justify-content-between flex-wrap mb-4">
              {myLobbies.map((lobby, index) => (
                <LobbyItem
                  key={lobby._id || index}
                  lobby={lobby}
                  onLobbyClick={handleLobbyClick}
                />
              ))}
            </div>
            <p className="instruction-text p-0 px-2 m-0 opacity-_8 text-center letter-spacing-_22 line-height-30 font-weight-300 small-txt txt-FFF font-family-poppins">
              Click to open lobby
            </p>
          </>
        ) : (
          <p className="no-lobbies-text p-0 px-2 m-0 opacity-_8 text-center letter-spacing-_22 line-height-30 font-weight-300 small-txt txt-FFF font-family-poppins">
            No Active Lobby found
          </p>
        )}
      </div>
    </div>
  );
};

const ScanQrCode = () => {
  const navigate = useNavigate();

  return (
    <div className="scan-qr-container">
      <div className="qr-code-wrapper mb-4 pb-3 d-flex align-items-center justify-content-center">
        <CustomSvg name="qrCode" />
      </div>
      <button
        onClick={() => navigate('/games/waiting-room')}
        className="scan-btn w-100 bg-BD3193 d-flex align-items-center justify-content-center p-2 mb-4"
      >
        <p className="p-0 m-0 small-txt txt-FFF font-weight-500 font-family-poppins mx-1">
          Enter
        </p>
        <div className="m-0 p-0 mx-2 d-flex align-items-center">
          <CustomSvg name="arrow-right" />
        </div>
      </button>
      <div className="qr-instructions">
        <p className="p-0 px-2 m-0 opacity-_8 text-center letter-spacing-_22 line-height-30 font-weight-300 small-txt txt-FFF font-family-poppins">
          QR Codes are unique and different for each competition, you can invite
          your friends to join the competition
        </p>
      </div>
    </div>
  );
};

const JoinLobby = () => {
  const [activeRoute, setActiveRoute] = useState('enterPin');
  const [isLeftBlockOpen, setIsLeftBlockOpen] = useState(true);
  const [isRightBlockOpen, setIsRightBlockOpen] = useState(true);

  const blocksOpen = useMemo(() => {
    if (isLeftBlockOpen && isRightBlockOpen) return 'both';
    if (!isLeftBlockOpen && !isRightBlockOpen) return 'none';
    return 'one';
  }, [isLeftBlockOpen, isRightBlockOpen]);

  const mainContentClass = useMemo(() => {
    switch (blocksOpen) {
      case 'both': return 'col-lg-8 col-md-8';
      case 'one': return 'col-lg-9 col-md-9';
      case 'none': return 'col-lg-10 col-md-10';
      default: return '';
    }
  }, [blocksOpen]);

  const renderActiveComponent = () => {
    switch (activeRoute) {
      case 'enterPin': return <EnterPin />;
      case 'qrCode': return <ScanQrCode />;
      case 'myLobbies': return <MyLobbies />;
      default: return null;
    }
  };

  return (
    <div className="dashboard" style={{ minHeight: '100vh' }}>
      <DashboardHeader />

      <div className="d-flex mt-4 px-4">
        {/* Mobile Controls */}
        <div className="d-flex flex-column w-100">
          <div className="d-lg-none d-md-none d-flex justify-content-between mb-4">
            <div className="col-6">
              <CollapseBlock isSmallScreen={true} />
            </div>
            <div className="col-6">
              <CollapseBlockRight isSmallScreen={true} />
            </div>
          </div>

          {/* Main Layout - Responsive for all screens */}
          <div className="d-flex w-100 align-items-start">
            {/* Left Sidebar - Hidden on mobile */}
            <div className={`d-none d-md-block ${isLeftBlockOpen ? 'col-lg-2 col-md-2' : 'col-lg-1 col-md-1'}`}>
              <CollapseBlock setIsLeftBlockOpen={setIsLeftBlockOpen} />
            </div>

            {/* Main Content */}
            <div className={`${mainContentClass} col-12 col-md-auto px-lg-4 px-md-4 px-0`}>
              <h1 className="m-0 p-0 mb-3 font-weight-700  font-family-quantico txt-large txt-FFF">
                Join <span className="create-lobby-title-span">Lobby</span>
              </h1>
              <p className="m-0 p-0 mb-4 regular-txt font-weight-300 font-family-poppins txt-FFF opacity-_7">
                {activeRoute === 'myLobbies'
                  ? 'Lobbies you belong to that are still active'
                  : 'We\'ve sent the pin to your email address. Check your email and enter the pin below'}
              </p>

              <div className="d-flex flex-row gap-4 mb-5">
                {NAVIGATION_TABS.map((tab) => (
                  <NavigationTab
                    key={tab.id}
                    {...tab}
                    isActive={activeRoute === tab.id}
                    onClick={setActiveRoute}
                  />
                ))}
              </div>

              {renderActiveComponent()}
            </div>

            {/* Right Sidebar - Hidden on mobile */}
            <div className={`d-none d-md-block ${isRightBlockOpen ? 'col-lg-2 col-md-2' : 'col-lg-1 col-md-1'}`}>
              <CollapseBlockRight setIsRightBlockOpen={setIsRightBlockOpen} />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default JoinLobby;
